<ngb-toast
  *ngFor="let toast of toastService.toasts"
  [class]="toast.className"
  [header]="toast.headertext"
  [autohide]="true"
  [delay]="toast.delay || 5000"
  (hide)="toastService.remove(toast)"
>
	{{ toast.body }}
</ngb-toast>